import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../shared/base-classes/base.component';
import { IBellScedulesListFilters } from '../../bell-schedules-models/bell-schedules-filters.interface';

@Component({
  selector: 'app-bell-schedules-list-filters',
  templateUrl: './bell-schedules-list-filters.template.html',
  styleUrls: ['./bell-schedules-list-filters.scss'],
})
export class AppBellSchedulesListFilters extends BaseComponent {
  @Input() filters: IBellScedulesListFilters;

  @Output() filtersUpdated: EventEmitter<IBellScedulesListFilters>;

  constructor() {
    super();
    this.filtersUpdated = new EventEmitter<IBellScedulesListFilters>();
  }
}